/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "telegram-white-0358cd45--sprite",
  "use": "telegram-white-0358cd45--sprite-usage",
  "viewBox": "0 0 25 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 20\" id=\"telegram-white-0358cd45--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.884 19.78a1.19 1.19 0 001.107.144 1.16 1.16 0 00.724-.84C21.584 15 23.692 4.664 24.483.948a.78.78 0 00-.26-.758.8.8 0 00-.797-.14C19.233 1.602 6.32 6.447 1.042 8.4a.827.827 0 00-.542.8c.012.353.25.66.593.763a425.68 425.68 0 015.474 1.693s1.452 4.385 2.21 6.615c.094.28.313.5.602.576a.866.866 0 00.811-.207l3.096-2.923s3.572 2.62 5.598 4.062zm-11.01-8.678l1.68 5.538.372-3.507 10.185-9.186a.278.278 0 00.033-.377.284.284 0 00-.376-.064L7.874 11.102z\" fill=\"#fff\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
